import { createApi } from '@reduxjs/toolkit/query/react';

import { IMyCourse } from '@/interfaces/course';
import { IPaginationParams, IPaginationResponse } from '@/interfaces/pagination';
import { IShelves } from '@/interfaces/shelves';

import { axiosBaseQuery } from './query';

export const shelvesApi = createApi({
  baseQuery: axiosBaseQuery(),
  reducerPath: 'shelvesApi',
  endpoints(build) {
    return {
      getShelves: build.query<IShelves[], void>({
        query: () => ({
          formatResponse: response => response.data.data.filter((shelf: IShelves) => shelf.type === 'shelf'),
          url: '/learner/showcase/shelves'
        })
      }),
      getShelf: build.query<IPaginationResponse<IMyCourse[]>, Partial<IPaginationParams> & { id: number }>({
        forceRefetch({ currentArg, previousArg }) {
          return JSON.stringify(currentArg) !== JSON.stringify(previousArg);
        },
        serializeQueryArgs: ({ endpointName, queryArgs }) => {
          return endpointName + JSON.stringify(queryArgs);
        },
        merge: (currCache, newCache) => {
          currCache.total_pages = newCache.total_pages;
          currCache.page = newCache.page;
          currCache.links = newCache.links;

          if (newCache.page.page === 1) {
            currCache.data = newCache.data;
          } else {
            currCache.data.push(...newCache.data);
          }
        },
        query: ({ id, ...params }) => ({
          formatResponse: response => {
            return response.data;
          },
          url: `/learner/showcase/shelf/${id}/courses`,
          params: {
            ...params,
            showShelf: true
          }
        })
      })
    };
  }
});

export const { useGetShelvesQuery, useGetShelfQuery } = shelvesApi;
